import { keyframes } from '@emotion/react'
import { greenMFC } from '../theme'
import { palette } from './colors'

export const ripple = keyframes(`
    0% {
        transform: scale(.8);
        opacity: 1;
    }
    100% {
        transform: scale(2.4);
        opacity: 0;
    }
    `)

export const squish = keyframes({
    '0%': {
        transform: 'rotateX(0deg)',
        backgroundColor: 'rgba(56, 142, 60, 0.2)',
    },
    '50%': {
        transform: 'rotateX(90deg)',
        backgroundColor: 'rgba(56, 142, 60, 1)',
    },
    '100%': {
        transform: 'rotateX(180deg)',
        backgroundColor: 'rgba(56, 142, 60, .2)',
    },
})

export const pulsate = keyframes({
    '0%': {
        transform: 'scale(.90)',
        backgroundColor: 'rgba(56, 142, 60, 0.2)',
        boxShadow: '0 0 0 0 rgba(56, 142, 60, .8)',
    },
    '70%': {
        transform: 'scale(1.05)',
        backgroundColor: 'rgba(56, 142, 60, 1)',
        boxShadow: '0 0 0 .3rem rgba(56, 142, 60, 0)',
    },
    '100%': {
        transform: 'scale(.90)',
        backgroundColor: 'rgba(56, 142, 60, .2)',
        boxShadow: '0 0 0 0 rgba(56, 142, 60, 0)',
    },
})

export const pulse = keyframes({
    '0%': {
        transform: 'scale(1)',
        opacity: 1,
    },
    '50%': {
        transform: 'scale(1.2)',
        opacity: 0.8,
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1,
    },
})

export const rotatingClockwise = keyframes({
    from: {
        transform: 'rotate(0deg)',
    },
    to: {
        transform: 'rotate(360deg)',
    },
})

export const online = keyframes(`
0% {
    color: ${palette.primary};
    opacity: 1;
}
50% {
    color:${greenMFC};
    opacity: 0.7;
}
100% {
    color: ${palette.primary};
    opacity: 1;
}
`)
